module.exports = "/_next/static/images/wom2-22fee38f79a811d8f5d42ef919e5e984.png";